export default {
  setToken(state, { token }) {
    state.token = token;
    localStorage.setItem('accessToken', token);
  },
  setEmail(state, { email }) {
    state.email = email;
    localStorage.setItem('email', email);
  },
  setName(state, { name }) {
    state.name = name;
  },
  setTenant(state, { tenant }) {
    state.tenant = tenant;
  },
  setLoginData(state, loginData) {
    state.loginData = loginData;
  },
  setOrigin(state, { value }) {
    localStorage.setItem('originBackoffice', value);
    state.originBackoffice = value;
  },
  setHasLogged(state, { hasLogged }) {
    state.hasLogged = hasLogged;
  },
  setPermissionRoutes(state, { routes }) {
    state.permissionRoutes = routes;
    localStorage.removeItem("permissionRoutes")
    localStorage.setItem('permissionRoutes', JSON.stringify(routes));
  }
}